<template>
  <header>
    <div class="header-container">
      <div class="header-bg" v-bind:style="{ 'background-image': backgroundPath }">
        <div class="header-content">
          <router-link :to="{name: 'Home'}"><img :src="getStaticPath(logoPath)" class="logo" alt="Logo" /></router-link>
          <!--Large-Device Only-->
          <p class="header-text hidden-md-down">{{ headerText }}
          <!--Non-Mobile Only-->
          <div class="right-header-content ml-auto">
            <!--Non-Mobile Only-->
            <social-media-buttons class="hidden-md-down float-right mt-0" :media-links="mediaLinks"></social-media-buttons>
            <p class="issn hidden-sm-down">Online ISSN: <strong>{{ issn }}</strong></p>
            <!--Non-Mobile Only-->
            <!--TODO:  This button will open a new window with an external link (URL TBD) -->
            <button class="button-primary">Submit Paper</button>
          </div>
        </div>
      </div>
    </div>
    <div id="navWrapper" class="nav-wrapper" v-bind:class="{ fixed: scrolled }">
      <!--Non-Mobile Only-->
      <div class="container hidden-sm-down">
        <header-nav></header-nav>
      </div>
      <!--Non-Mobile Only-->
      <div class="menu-container hidden-md-up"  v-bind:class="{ scrolled: scrolled }">
        <header-nav></header-nav>
      </div>
    </div>
  </header>
</template>

<script>
  import HeaderNav from '@/components/main-layout/header-nav/HeaderNavComponent'
  import SocialMediaButtons from '@/components/main-layout/shared/SocialMediaButtonsComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  let navWrapper = document.getElementById('navWrapper')
  let scrollPosition = navWrapper ? navWrapper.offsetTop : 0

  export default {
    components: {
      SocialMediaButtons,
      HeaderNav
    },
    name: 'header-area',
    mixins: [ UtilityMixin ],
    data () {
      var images = require.context('../../../assets/img/' + process.env.SITE, false, /\.png$/)
      return {
        headerText: process.env.DESCRIPTION,
        logoPath: 'img/' + process.env.SITE + '/header-logo.png',
        backgroundPath: 'url(' + images('./header-img.png') + ')',
        issn: process.env.ISSN,
        mediaLinks: {
          facebookUrl: process.env.SOCIAL_FB_URL,
          twitterUrl: process.env.SOCIAL_TW_URL,
          youTubeUrl: process.env.SOCIAL_YT_URL,
          googlePlusUrl: process.env.SOCIAL_GP_URL,
          linkedInUrl: process.env.SOCIAL_LI_URL
        },
        scrolled: false
      }
    },
    methods: {
      handleScroll () {
        this.scrolled = window.scrollY > scrollPosition
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>


<style lang="scss" scoped>

  header {
    .header-container {
      margin: 0 auto;
      .header-bg {
        border-top: 3px solid $primary-color;
        background-repeat: no-repeat;
        background-position: top left;
        border-bottom: 1px solid $header-bottom-border;
        height: 127px;
        .header-content {
          display: flex;
          justify-content: flex-start;
          height: inherit;
          align-items: center;
          .container {
            height: 100%;
          }

          .logo {
            margin-left: 15px;
            max-height: 100%;
          }

          p.header-text {
            font-family: 'Merriweather', serif;
            color: $accent-color-1;
            padding-right: 20px;
            margin-left: -15px;
            margin-bottom: 0;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            line-height: 17px;
          }

          .right-header-content {
            padding-right: 30px;
            .button-primary {
              min-width: 160px;
            }

            p.issn {
              font-family: 'Open Sans', sans-serif;
              font-size: 14px;
              text-align: right;
              color: $primary-color;
              margin: 5px 0;
              clear: right;

              em {
                font-weight: 600;
              }
            }
          }
        }
      }
    }
    .nav-wrapper {
      background-color: $white;
      margin: auto;
      @media (max-width: ($breakpoint-md - 1px)) {
        height: 1px;
      }
        &.fixed {
        background: $white;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 2;
        border-top: 3px solid $primary-color;
        border-bottom: 1px solid $fixed-header-bottom-border;
        -webkit-animation: fadein .5s; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: fadein .5s; /* Firefox < 16 */
        -ms-animation: fadein .5s; /* Internet Explorer */
        -o-animation: fadein .5s; /* Opera < 12.1 */
        animation: fadein .5s;
        > div {
          background-color: $white;
        }
      }
    }
  }

  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Opera < 12.1 */
  @-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  @media (max-width: ($breakpoint-md - 1px)) {
    header {
      .header-container{
        .header-bg {
          background-size: cover;
          .header-content {
            align-items: flex-start;
            .logo {
              width: 200px;
            }
            .button-primary {
              margin-top: 22px;
            }
          }
        }
      }
      .nav-wrapper {
        .menu-container {
          top: -50px;
          position: relative;
          margin-bottom: -40px;
          pading-left: 0px !important;
          &.scrolled {
             top: 0px;
           }
        }
      }
    }
  }

  @media (min-width: $breakpoint-md) {
    .header-container, .nav-wrapper{
      width: 990px;
      max-width: 100%;
    }
  }
  @media (min-width: $breakpoint-xl) {
    .header-container, .nav-wrapper{
      width: 1220px;
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderAreaComponent.vue?4126c19e